var HomePageSlider = function() {
	$(".who-we-are-section .menu-item").on("click", function(){
		$(this).addClass("active").siblings().removeClass("active");
		$(this).parents(".who-we-are-section").find(".slide:visible").slideToggle();
		$("#" + $(this).attr("target")).slideToggle();
	});
};

module.exports = HomePageSlider;
